var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 5.83331L8.4706 10.5962C9.02158 10.9819 9.29707 11.1747 9.59672 11.2494C9.86142 11.3154 10.1383 11.3154 10.403 11.2494C10.7026 11.1747 10.9781 10.9819 11.5291 10.5962L18.3332 5.83331M5.6665 16.6666H14.3332C15.7333 16.6666 16.4334 16.6666 16.9681 16.3942C17.4386 16.1545 17.821 15.772 18.0607 15.3016C18.3332 14.7668 18.3332 14.0668 18.3332 12.6666V7.33331C18.3332 5.93318 18.3332 5.23312 18.0607 4.69834C17.821 4.22793 17.4386 3.84548 16.9681 3.6058C16.4334 3.33331 15.7333 3.33331 14.3332 3.33331H5.6665C4.26637 3.33331 3.56631 3.33331 3.03153 3.6058C2.56112 3.84548 2.17867 4.22793 1.93899 4.69834C1.6665 5.23312 1.6665 5.93318 1.6665 7.33331V12.6666C1.6665 14.0668 1.6665 14.7668 1.93899 15.3016C2.17867 15.772 2.56112 16.1545 3.03153 16.3942C3.56631 16.6666 4.26637 16.6666 5.6665 16.6666Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail01);
export default __webpack_public_path__ + "static/media/mail-01.1964e2bcc71bfb0b6c112639aeb0fcbe.svg";
export { ForwardRef as ReactComponent };